import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError, map, tap } from 'rxjs/operators';
import { RidersFilters, RiderDTO} from "../../models/riders";
import { ListResultDTO } from '../../../helpers/listResult.interface copy';
import { Order } from "../../models/order";
import { Status } from "../../models/status";


@Injectable({
  providedIn: "root"
})
export class LaravelRidersService {
  orders: Order[] = [];

  constructor(private httpClient: HttpClient) {}

  public get ROUTES() {
    return {
      list: environment.baseUrl + "/api/riders",
      store: environment.baseUrl + "/api/riders",
      show: environment.baseUrl + '/api/riders',
      inactive: environment.baseUrl + "/api/riders/inactive",
      destroy: environment.baseUrl + '/api/riders',
      freeOrders: environment.baseUrl + '/api/riders/orders/free',
      myOrders: environment.baseUrl + '/api/riders/orders/mine',
      assignMeToOrder: (orderId: number) => `${environment.baseUrl}/api/riders/orders/${orderId}/assign`,
      setOrderAsDelivered: (orderId: number) => `${environment.baseUrl}/api/riders/orders/${orderId}/delivered`,
    };
  }

  public list(
    page: number,
    per_page: number,
    order: string,
    direction: string,
    filters: RidersFilters,
    includes?: string[]
  ): Observable<ListResultDTO<RiderDTO>> {
    let params = {};
        if (order) params['order'] = '' + order;
        if (direction) params['direction'] = '' + direction;
        if (includes) params['includes[]'] = includes;
        if (filters) {
          if (filters.filter) params['filter'] = filters.filter;
          if (filters.defaultTenantId) params["defaultTenantId"] = "" + filters.defaultTenantId;

        }
        if (per_page) {
          params['per_page'] = '' + per_page;
          if (page) params['page'] = '' + page;
          return this.httpClient.get<ListResultDTO<RiderDTO>>(
            this.ROUTES.list,
            {
              params: new HttpParams({ fromObject: params }),
            }
          );
        } else {
          return this.httpClient
            .get<RiderDTO[]>(this.ROUTES.list, {
              params: new HttpParams({ fromObject: params }),
            })
            .pipe(
              map((results) => {
                return {
                  data: results,
                  total: results.length,
                };
              })
            );
        }
    //return this.httpClient.get(this.ROUTES.list);
  }

  public create(name: string, surname: string, phone: string) {
    let rider = {
      name: name,
      surname: surname,
      phone: phone
    };
    return this.httpClient.post(this.ROUTES.store, { rider: rider });
  }

  public update(id: number, name: string, surname: string, phone: string) {
    let rider = {
      id: id,
      name: name,
      surname: surname,
      phone: phone
    };
    return this.httpClient.put(this.ROUTES.store, { rider: rider });
  }

  public show(id: number): Observable<RiderDTO> {
      let params = { id: '' + id };
      return this.httpClient.get<RiderDTO>(this.ROUTES.show, {
        params: new HttpParams({
          fromObject: params,
        }),
      });
  }

  public upsert(rider: RiderDTO): Observable<RiderDTO> {
      if (rider.id) {
        return this.httpClient.put<RiderDTO>(`${this.ROUTES.store}/${rider.id}`, {
          ...rider,
        });
      } else {
        return this.httpClient.post<RiderDTO>(`${this.ROUTES.store}`, {
          ...rider,
        });
      }
  }

  public setInactive(id) {
    return this.httpClient.post(this.ROUTES.inactive, { id: id });
  }

  public delete(id: number) {
    //let params = new HttpParams().set("id", "" + id);
    return this.httpClient.delete(this.ROUTES.destroy + "/" + id);
  }
  
  public getFreeOrders(): Observable<Order[]> {
    return this.httpClient.get<Order[]>(this.ROUTES.freeOrders);
  }

  public getMyOrders(): Observable<Order[]> {
    return this.httpClient.get<Order[]>(this.ROUTES.myOrders);
  }
  
  public assignMeToOrder(orderId: number): Observable<any> {  
    return this.httpClient.patch(`${environment.baseUrl}/api/riders/orders/${orderId}/assign`, {}).pipe(
      tap((response: any) => {
        console.log('Risposta del server:', response);
      }),
      catchError((error) => {
        console.error('Errore nell\'assegnazione del rider all\'ordine:', error);
        return throwError(error);
      })
    );
  }

  public setOrderAsDelivered(orderId: number): Observable<any> {
    return this.httpClient.patch(`${environment.baseUrl}/api/riders/orders/${orderId}/delivered`, {}).pipe(
      tap((response: any) => {
        console.log('Risposta del server:', response);
      }),
      catchError((error) => {
        console.error('Errore nella consegna dell\'ordine:', error);
        return throwError(error);
      })
    );
  }
  
  
}
